import OtherUserProfile from '.';
const otherUserProfileRoutes = [
    {
        name: '/other-user-profile',
        deepLink: '/other-user-profile',
        component: OtherUserProfile,
    },
];
export default otherUserProfileRoutes;
